<form class="search-form rounded" [formGroup]="filterModel" (ngSubmit)="doFilter()">
  <input
    id="filter-text"
    type="search"
    name="filterText"
    placeholder="Filter..."
    formControlName="filterText"
    (ngModelChange)="doFilter()"
  />
  @if (filterIsActive) {
    <button type="reset" (click)="reset()">
      <i class="fa-utility fa-semibold fa-xmark"></i>
    </button>
  } @else {
    <button type="submit"><i class="fa-utility-fill fa-semibold fa-filter"></i></button>
  }
</form>
